import { ChevronRight } from '@carbon/icons-react';
import { cx } from 'class-variance-authority';
import {
    Breadcrumb as AriaBreadcrumb,
    Breadcrumbs as AriaBreadcrumbs,
    Link as AriaLink,
    type BreadcrumbProps,
    type BreadcrumbsProps,
    type LinkProps,
} from 'react-aria-components';

import styles from './breadcrumbs.module.css';

export function Breadcrumbs<T extends object>(props: BreadcrumbsProps<T>) {
    return <AriaBreadcrumbs {...props} className={cx(styles.breadcrumbs, props.className)} />;
}

/**
 * One breadcrumb of a trail.
 *
 * A breadcrumb renders as a link unless it is disabled. In contrast to the
 * default behavior of React Aria, even the current breadcrumb is enabled by
 * default.
 */
export function Breadcrumb({ isDisabled = false, render, ...props }: BreadcrumbProps & Omit<LinkProps, 'className'>) {
    return (
        <AriaBreadcrumb {...props} className={cx(styles.breadcrumb, props.className)}>
            {({ isCurrent }) => (
                <>
                    <AriaLink {...props} className={styles.link} isDisabled={isDisabled} render={render} />
                    {!isCurrent && <ChevronRight />}
                </>
            )}
        </AriaBreadcrumb>
    );
}
